// Small helper for rendering doctor names. India's medical registrars
// let doctors save their profile name either bare ("Krishna Bharath")
// or already-prefixed ("Dr. Krishna Bharath"). Templates that blindly
// concatenate "Dr. " end up with "Dr. Dr. Krishna Bharath" on the
// printed prescription — which we've now seen in production and which
// looks unprofessional on a medico-legal document.
//
// Use `formatDoctorName(name)` everywhere the UI displays a doctor
// name. Never re-prefix "Dr. " manually.

/**
 * Return the name with exactly one "Dr." prefix, regardless of
 * whether the stored value already starts with "Dr.", "Dr ", "dr.",
 * etc. Empty / missing names return "N/A".
 */
export function formatDoctorName(name) {
  const raw = String(name ?? '').trim();
  if (!raw) return 'N/A';
  // Strip a leading "Dr." / "Dr " / "dr." (case-insensitive, one or
  // more spaces / dots allowed). Handles "Dr.Krishna" (no space) too.
  const stripped = raw.replace(/^\s*dr\.?\s*/i, '').trim();
  if (!stripped) return 'N/A';
  return `Dr. ${stripped}`;
}
